import { useEffect } from 'react';
import _get from 'lodash/get';
import moment from 'moment';
import { dateKeyFormat } from 'helper/anytime-booking';

const useSelectDefaultDateTab = (
  timeSlots,
  timeSlotsInTabs,
  selectedTab,
  selectedPickupSlot,
  setSelectedTab,
) => {
  useEffect(
    () => {
      if (
        _get(timeSlots, 'length') > 0 &&
        timeSlotsInTabs &&
        Object.keys(timeSlotsInTabs).length > 0
      ) {
        const allTabs = Object.keys(timeSlotsInTabs);
        if (!selectedTab) {
          const preselectedTab =
            selectedPickupSlot &&
            selectedPickupSlot.from &&
            moment(selectedPickupSlot.from).format(dateKeyFormat);
          if (preselectedTab) {
            setSelectedTab(preselectedTab);
            return;
          }
          if (allTabs.length > 0) {
            setSelectedTab(allTabs[0]);
          }
        } else if (allTabs.length > 0 && allTabs.indexOf(selectedTab) === -1) {
          setSelectedTab(allTabs[0]);
        }
      }
    },
    [
      timeSlotsInTabs,
      timeSlots,
      setSelectedTab,
      selectedTab,
      selectedPickupSlot,
    ],
  );
};

export default useSelectDefaultDateTab;
